import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import { EMPTY_FIELD_MESSAGE } from '../../constants/generals';
import { IHistory } from '../../interfaces';
import { updatePassword } from '../../services/userService';
import { BasePage } from '../reusableComponents/BasePage';
import { FormFooter } from '../reusableComponents/FormComponents/FormFooter';
import { RRFInput } from '../reusableComponents/FormComponents/RRFInput';
import { Loader } from '../reusableComponents/Loader';

export interface IUpdatePasswordProps {
    userUID: string;
    history: IHistory;
}

export interface IUpdatePasswordState {
    oldPassword: string;
    newPassword: string;
    isLoading: boolean;
}

export class UpdatePasswordImpl extends React.PureComponent<IUpdatePasswordProps, IUpdatePasswordState> {
    constructor(props: IUpdatePasswordProps) {
        super(props);
        this.state = { oldPassword: '', newPassword: '', isLoading: false };
    }

    handleSubmit = async () => {
        const { oldPassword, newPassword } = this.state;
        const { history, userUID } = this.props;
        if (oldPassword.length <= 0 || newPassword.length <= 0) {
            toast.error(EMPTY_FIELD_MESSAGE, {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        this.setState({
            isLoading: true
        });
        await updatePassword(oldPassword, newPassword, userUID, this, history);
        this.setState({
            isLoading: false
        });
    }

    renderContent = (isLoading) => {
        return <div style={{ position: 'relative' }} >
            {isLoading ? <Loader type="submission" /> : ''}
            <RRFInput
                model=".oldPassword"
                type="password"
                onChange={e => this.setState({ oldPassword: e.target.value })}
                placeholder="Enter your old password..."
                id="Old_Password"
                label="Old Password:"
            />
            <RRFInput
                model=".newPassword"
                type="password"
                onChange={e => this.setState({ newPassword: e.target.value })}
                placeholder="Enter your new password..."
                id="New_Password"
                label="New Password:"
            />
            <FormFooter onSubmit={this.handleSubmit} onCancel={() => this.props.history.push('/home')} />
        </div>;
    }

    render() {
        return <BasePage pageTitle="Update Your Password">
            {this.renderContent(this.state.isLoading)}
        </BasePage>;
    }
}
export function mapStateToProps(state) {
    const userUID = state.login.get('UniqueId');
    return {
        userUID
    };
}
export const UpdatePassword =
    withRouter(connect<{}, {}, IUpdatePasswordProps>(mapStateToProps)(UpdatePasswordImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Profile/UpdatePassword.tsx